import { FC, SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  idPrefix: string
  size?: number
}

export const BetaSupporterAvatarFrame: FC<Props> = ({
  idPrefix,
  size = 80,
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 134 134"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M59.4281 114.76L66.0066 103.952L73.076 115.265L73.3353 115.68L73.7558 115.43C75.2337 114.55 79.5141 111.274 83.6447 107.933C85.7176 106.257 87.765 104.554 89.4209 103.112C91.0621 101.684 92.3568 100.479 92.8904 99.8123C94.9334 97.2587 98.1575 91.3952 99.9724 86.1639L99.9935 86.1029L99.9985 86.0385C100.504 79.484 98.6026 74.3109 96.0583 69.484L122.903 10.9138L123.356 12.4242C124.792 17.2132 125.939 22.0769 126.319 27.0298C126.425 28.4164 126.498 29.8011 126.5 31.0009C126.506 34.2063 126.011 38.3001 125.51 41.6092C125.26 43.2602 125.01 44.7093 124.822 45.7455C124.728 46.2635 124.65 46.6781 124.595 46.963C124.568 47.1054 124.547 47.2153 124.532 47.2895L124.515 47.3736L124.511 47.3947L124.51 47.3999L124.51 47.4011L124.51 47.4015L125.388 47.8153L130.892 41.0411C130.024 52.9792 128.532 59.8641 124.528 71.3352L124.073 72.6395L125.257 71.9287L129.355 69.4699C128.61 74.2701 127.141 78.9655 125.749 82.5839C125.004 84.5217 124.283 86.1445 123.713 87.3025C123.428 87.8822 123.182 88.3403 122.992 88.6612C122.897 88.8223 122.819 88.9421 122.761 89.0229C122.735 89.0584 122.716 89.0819 122.704 89.0959C122.642 89.1372 122.568 89.1981 122.508 89.2854C122.424 89.4071 122.37 89.5849 122.43 89.7785C122.481 89.9433 122.593 90.0415 122.657 90.0892C122.728 90.1412 122.802 90.1766 122.862 90.201C123.087 90.2927 123.415 90.3494 123.701 90.3877C123.952 90.4214 124.214 90.4463 124.433 90.4639C124.039 93.2907 123.466 95.5758 122.37 97.954C121.206 100.479 119.441 103.133 116.631 106.661C111.597 111.404 108.463 113.674 101.802 116.541L100.814 116.966L101.776 117.447L107.112 120.114C106.103 120.946 105.056 121.51 103.656 121.883C101.982 122.33 99.7858 122.507 96.5171 122.5C87.1376 121.913 82.6261 121.773 78.4142 122.507L77.872 122.602L78.0179 123.133C78.189 123.755 78.2895 124.153 78.4866 125C78.3605 125.523 78.2137 125.859 78.0282 126.144C77.8352 126.441 77.5885 126.702 77.2199 127.073L65.9933 131.466C64.9757 131.1 63.5254 130.567 62.3012 130.114C61.6532 129.874 61.0691 129.657 60.6471 129.5L60.1478 129.314L60.0123 129.264L59.9771 129.25L59.9736 129.249L59.9681 129.247L59.9616 129.244L59.9142 129.225L59.7338 129.152C59.5781 129.088 59.3554 128.997 59.088 128.886C58.5528 128.664 57.8393 128.364 57.1241 128.052C56.4072 127.739 55.6955 127.417 55.1611 127.149C54.8923 127.015 54.6793 126.899 54.5357 126.81C54.5072 126.792 54.4836 126.776 54.4642 126.763L54.464 126.763L54.3626 126.656C53.8227 126.087 53.637 125.725 53.5978 125.429C53.5587 125.134 53.6496 124.797 53.9439 124.23L53.9472 124.224L54.4472 123.224L54.809 122.5H54H35.5187C30.6356 122.134 28.3152 121.622 25.9972 120.09L31.7095 117.454L32.6908 117.001L31.7103 116.546C27.56 114.622 24.5795 113.002 21.9024 111.009C19.232 109.021 16.8452 106.647 13.8983 103.197C10.7003 98.4737 9.46345 95.6472 8.20731 90.7627L10.3429 91.4744L11.3556 91.8118L10.9666 90.8178L6.48024 79.3527L4.2748 69.6525L8.21428 72.4096L9.54012 73.3375L8.96878 71.8235C6.65241 65.685 5.63798 62.1969 4.49288 55.9104L4.48992 55.8941L4.48589 55.8781C3.03884 50.1223 2.63704 46.7567 2.52366 41.3783L7.62035 47.3254L8.48822 46.8921C6.83354 39.4035 6.42933 35.1892 6.99862 27.5371L6.9994 27.5267L6.99974 27.5162C7.23016 20.4148 8.05763 16.6168 10.0814 10.779C11.6591 13.9334 13.1462 16.8948 14.554 19.6984C24.7335 39.9702 30.7733 51.9983 37.0279 69.1647L37.4606 70.4603C34.7205 75.8854 33.3391 80.1969 33.6077 84.5412C33.8794 88.9347 35.8334 93.2814 39.588 98.7819L39.6088 98.8124L39.6339 98.8395C45.9647 105.685 50.0422 109.285 58.7289 114.919L59.1605 115.199L59.4281 114.76Z"
          fill="white"
          stroke="white"
        />
        <mask
          id="mask0_65522_77341"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="-29"
          y="6"
          width="172"
          height="118"
        >
          <rect x="-29" y="6" width="172" height="118" fill="#ABABAB" />
        </mask>
        <g mask="url(#mask0_65522_77341)">
          <g filter={`url(#${idPrefix}filter0_d_65522_77341)`}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M99.6531 87.8844C100.863 80.2896 98.1849 73.9451 95.2042 70.3153L101.384 55.5774L123.07 9.32438C127.793 19.7688 132.222 47.4712 112.148 74.7256C106.552 82.3236 102.514 86.3327 99.6531 87.8844Z"
              fill={`url(#${idPrefix}paint0_linear_65522_77341)`}
            />
            <path
              d="M102.554 56.0991L122.971 12.5544C127.012 24.2355 129.314 49.2576 111.118 73.9639C106.908 79.6804 103.66 83.2442 101.208 85.2556C101.493 78.9008 99.2768 73.5626 96.6779 70.1147L102.554 56.0991Z"
              stroke={`url(#${idPrefix}paint1_linear_65522_77341)`}
              strokeWidth="2.56234"
            />
            <g filter={`url(#${idPrefix}filter1_d_65522_77341)`}>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M95.3437 98.4559C100.661 90.0503 100.522 82.2506 98.5043 76.5181L131.443 39.9397C130.692 58.2006 122.474 95.4633 95.6103 98.427C95.5209 98.4369 95.4321 98.4465 95.3437 98.4559Z"
                fill={`url(#${idPrefix}paint2_linear_65522_77341)`}
              />
            </g>
            <path
              d="M99.8711 76.8133L130.351 42.9655C129.654 51.8655 127.363 63.9608 122.506 74.5167C117.337 85.7524 109.377 95.0229 97.5395 97.1368C101.72 89.4573 101.641 82.3121 99.8711 76.8133Z"
              stroke={`url(#${idPrefix}paint3_linear_65522_77341)`}
              strokeWidth="2.13528"
            />
            <path
              opacity="0.8"
              d="M112.786 80.763L100.262 88.8193L99.5042 91.7585L112.786 80.763Z"
              fill={`url(#${idPrefix}paint4_linear_65522_77341)`}
            />
            <g filter={`url(#${idPrefix}filter2_d_65522_77341)`}>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M84.6795 110.081C93.0536 103.464 97.2968 96.8168 99.0083 90.7922L129.609 68.3462C127.882 84.5546 116.473 115.353 84.6795 110.081Z"
                fill={`url(#${idPrefix}paint5_linear_65522_77341)`}
              />
            </g>
            <path
              d="M99.9318 91.4416L128.227 70.6871C127.026 78.454 123.784 88.624 117.576 96.6166C111.096 104.959 101.392 110.94 87.2391 109.362C94.3667 103.272 98.2283 97.1405 99.9318 91.4416Z"
              stroke={`url(#${idPrefix}paint6_linear_65522_77341)`}
              strokeWidth="2.13528"
            />
            <path
              d="M114.262 93.6817L95.4291 98.6497L93.9889 100.995L114.262 93.6817Z"
              fill={`url(#${idPrefix}paint7_linear_65522_77341)`}
            />
            <g filter={`url(#${idPrefix}filter3_d_65522_77341)`}>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M94.5525 99.9192C90.8112 105.252 84.8265 110.793 75.7047 116.177C72.1805 118.257 69.1444 120.202 66.5414 122.019L66.2955 122.224C109.931 124.768 123.911 101.975 125.507 90.028L94.5525 99.9192Z"
                fill={`url(#${idPrefix}paint8_linear_65522_77341)`}
              />
            </g>
            <path
              d="M66.5396 122.021C69.143 120.204 72.1798 118.258 75.7049 116.178C84.8269 110.794 90.8117 105.253 94.5529 99.9196L125.507 90.0285"
              stroke={`url(#${idPrefix}paint9_linear_65522_77341)`}
              strokeWidth="2.13528"
            />
            <path
              d="M95.6565 114.798L85.34 109.423L83.2675 110.979L95.6565 114.798Z"
              fill={`url(#${idPrefix}paint10_linear_65522_77341)`}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M84.5146 110.213C81.9701 112.211 79.0482 114.205 75.7048 116.178C67.4844 121.03 61.9196 125.148 58.3133 128.611C58.7615 129.656 61.2421 129.531 64.981 127.324C72.5598 122.851 79.2772 122.092 91.1035 122.699C102.595 123.288 106.15 122.048 108.19 119.986C103.501 117.943 91.7724 113.096 84.5146 110.213Z"
              fill={`url(#${idPrefix}paint11_linear_65522_77341)`}
            />
            <path
              d="M76.2474 117.098C79.4173 115.227 82.2192 113.333 84.6877 111.431C91.1959 114.025 100.868 118.014 106.1 120.249C104.061 121.392 100.221 122.098 91.1582 121.633C79.2543 121.022 72.2848 121.774 64.4384 126.405C62.7547 127.399 61.4023 127.913 60.4476 128.098C63.9714 124.982 69.074 121.332 76.2474 117.098ZM59.2314 128.104C59.2315 128.104 59.2323 128.105 59.2338 128.106C59.2321 128.105 59.2314 128.104 59.2314 128.104Z"
              stroke={`url(#${idPrefix}paint12_linear_65522_77341)`}
              strokeWidth="2.13528"
            />
            <path
              d="M95.9385 69.1074C98.7586 72.7595 102.308 80.0683 100.975 85.2412"
              stroke={`url(#${idPrefix}paint13_linear_65522_77341)`}
              strokeWidth="2.65565"
            />
            <g filter={`url(#${idPrefix}filter4_d_65522_77341)`}>
              <path
                d="M77.2909 116.333C106.627 95.4083 103.359 79.9464 96.3448 69.7305C96.2205 69.5494 95.9535 69.5559 95.8342 69.7403C95.7736 69.8341 95.7685 69.9539 95.8199 70.053C102.177 82.3218 102.452 95.3477 75.3435 114.16C39.4483 137.178 44.5433 145.298 45.113 147.952C45.5688 150.075 47.6543 149.443 48.64 148.861C49.3205 142.976 50.1909 137.977 77.2909 116.333Z"
                fill={`url(#${idPrefix}paint14_linear_65522_77341)`}
              />
              <path
                d="M77.2909 116.333C106.64 95.3989 103.356 79.9325 96.3353 69.7167C96.2155 69.5423 95.9582 69.5486 95.8433 69.7263C95.7783 69.8268 95.7801 69.9571 95.8467 70.0566C103.612 81.6616 104.493 95.4669 75.3435 114.16C39.4483 137.178 44.5433 145.298 45.113 147.952C45.5688 150.075 47.6543 149.443 48.64 148.861C45.3082 145.843 48.116 137.143 77.2909 116.333Z"
                fill={`url(#${idPrefix}paint15_linear_65522_77341)`}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M75.3434 114.159C76.5043 114.34 78.2949 114.487 80.0008 114.43C86.0266 109.873 90.5216 105.533 93.7302 101.561C94.2379 100.855 94.7624 100.211 95.1776 99.6282C94.5711 99.472 93.6052 99.5697 92.5233 100.198C88.5993 104.512 83.0506 109.209 75.3434 114.159Z"
                fill={`url(#${idPrefix}paint16_linear_65522_77341)`}
              />
              <g filter={`url(#${idPrefix}filter5_f_65522_77341)`}>
                <path
                  d="M96.0835 69.3547V69.3547C95.8729 69.6806 95.8789 70.1014 96.0912 70.4262C103.627 81.9548 104.184 95.6649 75.3435 114.16C39.4483 137.178 44.5433 145.298 45.113 147.952C45.5688 150.075 47.6543 149.443 48.64 148.861"
                  stroke={`url(#${idPrefix}paint17_linear_65522_77341)`}
                  strokeWidth="1.18029"
                />
              </g>
              <g filter={`url(#${idPrefix}filter6_f_65522_77341)`}>
                <path
                  d="M45.5415 143.048C47.8343 135.447 57.4032 127.02 61.9737 123.879C66.7442 120.233 77.5833 112.606 82.1937 110.283"
                  stroke="#EED7B5"
                  strokeWidth="1.47536"
                />
              </g>
            </g>
          </g>
          <g filter={`url(#${idPrefix}filter7_d_65522_77341)`}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M33.6654 87.885C32.4554 80.29 35.1335 73.9454 38.1142 70.3155L31.9408 55.592L10.2477 9.32455C5.52444 19.769 1.09617 47.4713 21.1694 74.7257C26.766 82.3245 30.8048 86.3336 33.6654 87.885Z"
              fill={`url(#${idPrefix}paint18_linear_65522_77341)`}
            />
            <path
              d="M30.764 56.0991L10.3475 12.5544C6.30623 24.2355 4.0039 49.2576 22.2004 73.9639C26.4107 79.6804 29.6584 83.2441 32.1104 85.2555C31.8251 78.9007 34.0416 73.5626 36.6406 70.1147L30.764 56.0991Z"
              stroke={`url(#${idPrefix}paint19_linear_65522_77341)`}
              strokeWidth="2.56234"
            />
            <g filter={`url(#${idPrefix}filter8_d_65522_77341)`}>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37.9745 98.4524C32.6572 90.0473 32.796 82.248 34.8134 76.5155L1.87333 39.9359C2.62452 58.1968 10.8428 95.4595 37.7065 98.4233C37.7963 98.4332 37.8856 98.4429 37.9745 98.4524Z"
                fill={`url(#${idPrefix}paint20_linear_65522_77341)`}
              />
            </g>
            <path
              d="M33.4472 76.8133L2.96715 42.9655C3.66422 51.8656 5.95583 63.9608 10.8122 74.5167C15.9814 85.7525 23.9413 95.023 35.7789 97.1368C31.5984 89.4574 31.6773 82.3121 33.4472 76.8133Z"
              stroke={`url(#${idPrefix}paint21_linear_65522_77341)`}
              strokeWidth="2.13528"
            />
            <path
              opacity="0.8"
              d="M20.5328 80.763L33.0567 88.8193L33.8141 91.7585L20.5328 80.763Z"
              fill={`url(#${idPrefix}paint22_linear_65522_77341)`}
            />
            <g filter={`url(#${idPrefix}filter9_d_65522_77341)`}>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M48.6379 110.081C40.2638 103.464 36.0206 96.8168 34.3091 90.7922L3.70805 68.3462C5.4358 84.5546 16.8446 115.353 48.6379 110.081Z"
                fill={`url(#${idPrefix}paint23_linear_65522_77341)`}
              />
            </g>
            <path
              d="M33.3856 91.4416L5.09057 70.6871C6.29132 78.454 9.53306 88.624 15.7413 96.6166C22.2209 104.959 31.9255 110.94 46.0783 109.362C38.9506 103.272 35.0891 97.1405 33.3856 91.4416Z"
              stroke={`url(#${idPrefix}paint24_linear_65522_77341)`}
              strokeWidth="2.13528"
            />
            <path
              d="M19.0557 93.6817L37.8883 98.6497L39.3285 100.995L19.0557 93.6817Z"
              fill={`url(#${idPrefix}paint25_linear_65522_77341)`}
            />
            <g filter={`url(#${idPrefix}filter10_d_65522_77341)`}>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M38.765 99.9189C42.5062 105.252 48.491 110.793 57.613 116.177C61.1391 118.258 64.1766 120.205 66.7806 122.022L67.0229 122.224C23.3878 124.768 9.40723 101.975 7.81158 90.028L38.765 99.9189Z"
                fill={`url(#${idPrefix}paint26_linear_65522_77341)`}
              />
            </g>
            <path
              d="M66.7778 122.021C64.1744 120.204 61.1376 118.258 57.6125 116.178C48.4905 110.794 42.5057 105.253 38.7645 99.9196L7.81061 90.0285"
              stroke={`url(#${idPrefix}paint27_linear_65522_77341)`}
              strokeWidth="2.13528"
            />
            <path
              d="M37.6609 114.798L47.9774 109.423L50.0499 110.979L37.6609 114.798Z"
              fill={`url(#${idPrefix}paint28_linear_65522_77341)`}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M48.8037 110.213C51.3482 112.211 54.2702 114.205 57.6136 116.178C65.834 121.03 71.3987 125.148 75.005 128.611C74.5569 129.656 72.0763 129.531 68.3373 127.324C60.7585 122.851 54.0411 122.092 42.2148 122.699C30.7229 123.288 27.1688 122.048 25.1281 119.986C29.8172 117.943 41.546 113.096 48.8037 110.213Z"
              fill={`url(#${idPrefix}paint29_linear_65522_77341)`}
            />
            <path
              d="M57.0709 117.098C53.901 115.227 51.0992 113.333 48.6307 111.431C42.1224 114.025 32.4507 118.014 27.218 120.249C29.2569 121.392 33.0969 122.098 42.1601 121.633C54.0641 121.022 61.0336 121.774 68.88 126.405C70.5636 127.399 71.9161 127.913 72.8708 128.098C69.3469 124.982 64.2444 121.332 57.0709 117.098ZM74.0869 128.104C74.0869 128.104 74.0861 128.105 74.0846 128.106C74.0862 128.105 74.087 128.104 74.0869 128.104Z"
              stroke={`url(#${idPrefix}paint30_linear_65522_77341)`}
              strokeWidth="2.13528"
            />
            <path
              d="M37.3799 69.1074C34.5598 72.7595 31.0103 80.0683 32.3434 85.2412"
              stroke={`url(#${idPrefix}paint31_linear_65522_77341)`}
              strokeWidth="2.65565"
            />
            <g filter={`url(#${idPrefix}filter11_d_65522_77341)`}>
              <path
                d="M56.0274 116.333C26.6917 95.4083 29.9596 79.9465 36.9735 69.7305C37.0979 69.5494 37.3649 69.5559 37.4841 69.7404C37.5448 69.8341 37.5498 69.9539 37.4985 70.0531C31.141 82.3218 30.8661 95.3477 57.9748 114.16C93.8701 137.178 88.7751 145.298 88.2053 147.952C87.7495 150.075 85.6641 149.443 84.6783 148.861C83.9979 142.976 83.1274 137.977 56.0274 116.333Z"
                fill={`url(#${idPrefix}paint32_linear_65522_77341)`}
              />
              <path
                d="M56.0274 116.333C26.6785 95.3989 29.9625 79.9325 36.983 69.7167C37.1029 69.5423 37.3601 69.5486 37.475 69.7263C37.5401 69.8268 37.5382 69.9571 37.4716 70.0566C29.7068 81.6617 28.825 95.4669 57.9748 114.16C93.8701 137.178 88.7751 145.298 88.2053 147.952C87.7495 150.075 85.6641 149.443 84.6783 148.861C88.0101 145.843 85.2023 137.143 56.0274 116.333Z"
                fill={`url(#${idPrefix}paint33_linear_65522_77341)`}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M57.9749 114.159C56.814 114.34 55.0235 114.487 53.3176 114.43C47.2917 109.873 42.7967 105.533 39.5882 101.561C39.0805 100.855 38.556 100.211 38.1408 99.6283C38.7473 99.472 39.7132 99.5697 40.7951 100.198C44.7191 104.512 50.2678 109.209 57.9749 114.159Z"
                fill={`url(#${idPrefix}paint34_linear_65522_77341)`}
              />
              <g filter={`url(#${idPrefix}filter12_f_65522_77341)`}>
                <path
                  d="M37.2348 69.3547V69.3547C37.4455 69.6806 37.4395 70.1014 37.2272 70.4262C29.6915 81.9548 29.1339 95.6649 57.9749 114.16C93.8701 137.178 88.7751 145.298 88.2054 147.952C87.7496 150.075 85.6641 149.443 84.6783 148.861"
                  stroke={`url(#${idPrefix}paint35_linear_65522_77341)`}
                  strokeWidth="1.18029"
                />
              </g>
              <g filter={`url(#${idPrefix}filter13_f_65522_77341)`}>
                <path
                  d="M87.7769 143.048C85.484 135.447 75.9152 127.02 71.3446 123.879C66.5741 120.233 55.7351 112.606 51.1246 110.283"
                  stroke="#EED7B5"
                  strokeWidth="1.47536"
                />
              </g>
            </g>
          </g>
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M66.1132 131.866C66.125 131.862 66.1379 131.862 66.1497 131.866L66.1781 131.877C66.1986 131.885 66.2205 131.869 66.2204 131.847V131.847C66.2203 131.834 66.2284 131.823 66.2406 131.818L77.0398 127.72C78.7989 127.052 79.5164 124.949 78.5321 123.345L66.0467 103.006C66.0458 103.005 66.0433 103.005 66.0433 103.007V103.007V103.007C66.0433 103.005 66.0407 103.005 66.0397 103.006L53.5622 123.333C52.5753 124.94 53.2995 127.049 55.0659 127.711L66.0231 131.819C66.0352 131.823 66.0433 131.835 66.0433 131.848V131.848C66.0433 131.87 66.065 131.885 66.0853 131.877L66.1132 131.866Z"
          fill="white"
        />
        <mask
          id="mask1_65522_77341"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="53"
          y="103"
          width="26"
          height="29"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M66.1128 131.866C66.1246 131.862 66.1375 131.862 66.1493 131.866L66.1777 131.877C66.1983 131.885 66.2201 131.869 66.22 131.847V131.847C66.2199 131.834 66.228 131.823 66.2402 131.818L77.0951 127.699C78.8252 127.042 79.531 124.973 78.5628 123.396L66.0429 103.001C66.0429 103.001 66.0429 103.001 66.0429 103.001V103.001C66.0429 103.001 66.0428 103.001 66.0428 103.001L53.5306 123.384C52.5599 124.965 53.2722 127.039 55.0095 127.69L66.0227 131.819C66.0348 131.823 66.0429 131.835 66.0429 131.848V131.848C66.0429 131.87 66.0646 131.885 66.0849 131.877L66.1128 131.866Z"
            fill={`url(#${idPrefix}paint36_linear_65522_77341)`}
          />
        </mask>
        <g mask="url(#mask1_65522_77341)">
          <path
            d="M66.1205 132.371L80.3789 126.515L66.1205 100.799L66.1205 132.371Z"
            fill={`url(#${idPrefix}paint37_linear_65522_77341)`}
          />
          <path
            d="M66.1208 132.371L51.8623 126.515L66.1208 100.799L66.1208 132.371Z"
            fill={`url(#${idPrefix}paint38_linear_65522_77341)`}
          />
        </g>
      </g>
      <defs>
        <filter
          id={idPrefix + 'filter0_d_65522_77341'}
          x="42.958"
          y="9.32227"
          width="89.6426"
          height="142.691"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.38125 0 0 0 0 0.416833 0 0 0 0 0.508333 0 0 0 0.38 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_65522_77341"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_65522_77341"
            result="shape"
          />
        </filter>
        <filter
          id={idPrefix + 'filter1_d_65522_77341'}
          x="86.8026"
          y="34.2454"
          width="47.4878"
          height="69.9038"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2.84704" />
          <feGaussianBlur stdDeviation="2.84704" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.446731 0 0 0 0 0.444028 0 0 0 0 0.579167 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_65522_77341"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_65522_77341"
            result="shape"
          />
        </filter>
        <filter
          id={idPrefix + 'filter2_d_65522_77341'}
          x="76.1386"
          y="62.6516"
          width="56.3179"
          height="53.7241"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2.84704" />
          <feGaussianBlur stdDeviation="2.84704" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.446731 0 0 0 0 0.444028 0 0 0 0 0.579167 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_65522_77341"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_65522_77341"
            result="shape"
          />
        </filter>
        <filter
          id={idPrefix + 'filter3_d_65522_77341'}
          x="52.0607"
          y="72.8414"
          width="87.6814"
          height="60.863"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2.95072" />
          <feGaussianBlur stdDeviation="7.11761" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.365689 0 0 0 0 0.351111 0 0 0 0 0.533333 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_65522_77341"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_65522_77341"
            result="shape"
          />
        </filter>
        <filter
          id={idPrefix + 'filter4_d_65522_77341'}
          x="43.958"
          y="69.0352"
          width="59.1768"
          height="82.9785"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.7 0 0 0 0 0.526167 0 0 0 0 0.265417 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_65522_77341"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_65522_77341"
            result="shape"
          />
        </filter>
        <filter
          id={idPrefix + 'filter5_f_65522_77341'}
          x="43.5154"
          y="68.5925"
          width="57.9965"
          height="81.8637"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.221304"
            result="effect1_foregroundBlur_65522_77341"
          />
        </filter>
        <filter
          id={idPrefix + 'filter6_f_65522_77341'}
          x="38.9335"
          y="103.724"
          width="49.4933"
          height="45.4376"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.95072"
            result="effect1_foregroundBlur_65522_77341"
          />
        </filter>
        <filter
          id={idPrefix + 'filter7_d_65522_77341'}
          x="0.717773"
          y="9.32227"
          width="89.6426"
          height="142.691"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.38125 0 0 0 0 0.416833 0 0 0 0 0.508333 0 0 0 0.38 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_65522_77341"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_65522_77341"
            result="shape"
          />
        </filter>
        <filter
          id={idPrefix + 'filter8_d_65522_77341'}
          x="-6.66809"
          y="34.2415"
          width="47.4897"
          height="69.9058"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2.84704" />
          <feGaussianBlur stdDeviation="2.84704" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.446731 0 0 0 0 0.444028 0 0 0 0 0.579167 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_65522_77341"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_65522_77341"
            result="shape"
          />
        </filter>
        <filter
          id={idPrefix + 'filter9_d_65522_77341'}
          x="-4.83312"
          y="62.6516"
          width="56.3179"
          height="53.7241"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2.84704" />
          <feGaussianBlur stdDeviation="2.84704" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.446731 0 0 0 0 0.444028 0 0 0 0 0.579167 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_65522_77341"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_65522_77341"
            result="shape"
          />
        </filter>
        <filter
          id={idPrefix + 'filter10_d_65522_77341'}
          x="-6.4237"
          y="72.8414"
          width="87.6814"
          height="60.863"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2.95072" />
          <feGaussianBlur stdDeviation="7.11761" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.365689 0 0 0 0 0.351111 0 0 0 0 0.533333 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_65522_77341"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_65522_77341"
            result="shape"
          />
        </filter>
        <filter
          id={idPrefix + 'filter11_d_65522_77341'}
          x="32.1836"
          y="69.0352"
          width="59.1768"
          height="82.9785"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.7 0 0 0 0 0.526167 0 0 0 0 0.265417 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_65522_77341"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_65522_77341"
            result="shape"
          />
        </filter>
        <filter
          id={idPrefix + 'filter12_f_65522_77341'}
          x="31.8064"
          y="68.5925"
          width="57.9965"
          height="81.8637"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.221304"
            result="effect1_foregroundBlur_65522_77341"
          />
        </filter>
        <filter
          id={idPrefix + 'filter13_f_65522_77341'}
          x="44.8915"
          y="103.724"
          width="49.4933"
          height="45.4376"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.95072"
            result="effect1_foregroundBlur_65522_77341"
          />
        </filter>
        <linearGradient
          id={idPrefix + 'paint0_linear_65522_77341'}
          x1="122.597"
          y1="9.20246"
          x2="109.21"
          y2="66.2668"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.220856" stopColor="#FAFAFA" />
          <stop offset="1" stopColor="#D8D9E1" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint1_linear_65522_77341'}
          x1="122.928"
          y1="9.28552"
          x2="92.434"
          y2="81.2968"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8F8F9" stopOpacity="0.46" />
          <stop offset="0.575358" stopColor="#F8F8F9" />
          <stop offset="0.783289" stopColor="white" />
          <stop offset="0.884809" stopColor="white" stopOpacity="0.19" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint2_linear_65522_77341'}
          x1="121.095"
          y1="37.2728"
          x2="110.11"
          y2="82.9663"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.220856" stopColor="#FAFAFA" />
          <stop offset="1" stopColor="#D8D9E1" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint3_linear_65522_77341'}
          x1="121.605"
          y1="37.407"
          x2="99.2023"
          y2="96.2867"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8F8F9" stopOpacity="0.46" />
          <stop offset="0.292773" stopColor="#F8F8F9" stopOpacity="0.45" />
          <stop offset="0.629289" stopColor="white" stopOpacity="0.51" />
          <stop offset="0.742389" stopColor="white" stopOpacity="0.12" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint4_linear_65522_77341'}
          x1="105.208"
          y1="83.4075"
          x2="104.403"
          y2="93.0208"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.374859" stopColor="#AD8357" />
          <stop offset="0.986946" stopColor="#714538" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint5_linear_65522_77341'}
          x1="113.4"
          y1="64.1691"
          x2="104.519"
          y2="100.033"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.220856" stopColor="#FAFAFA" />
          <stop offset="1" stopColor="#D8D9E1" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint6_linear_65522_77341'}
          x1="113.878"
          y1="64.2945"
          x2="98.3749"
          y2="111.543"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8F8F9" stopOpacity="0.46" />
          <stop offset="0.21882" stopColor="#F8F8F9" stopOpacity="0.67" />
          <stop offset="0.45675" stopColor="white" stopOpacity="0.46" />
          <stop offset="0.742389" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint7_linear_65522_77341'}
          x1="101.883"
          y1="94.3469"
          x2="100.459"
          y2="102.848"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.374859" stopColor="#AD8357" />
          <stop offset="0.986946" stopColor="#714538" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint8_linear_65522_77341'}
          x1="101.605"
          y1="96.5625"
          x2="104.221"
          y2="116.621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EFEFEF" />
          <stop offset="0.411026" stopColor="#DEDFE6" />
          <stop offset="0.58979" stopColor="#D1D2D9" />
          <stop offset="1" stopColor="#D1D2D9" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint9_linear_65522_77341'}
          x1="122.996"
          y1="91.793"
          x2="101.24"
          y2="114.196"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8F8F9" stopOpacity="0.86" />
          <stop offset="0.319253" stopColor="#F8F8F9" />
          <stop offset="0.615431" stopColor="white" stopOpacity="0.88" />
          <stop offset="0.867925" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint10_linear_65522_77341'}
          x1="92.8364"
          y1="111.146"
          x2="88.2621"
          y2="107.607"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.374859" stopColor="#AD8357" />
          <stop offset="0.986946" stopColor="#714538" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint11_linear_65522_77341'}
          x1="85.9656"
          y1="110.488"
          x2="87.4036"
          y2="135.243"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0306468" stopColor="#DBDCE7" />
          <stop offset="0.274204" stopColor="#CBCCD7" />
          <stop offset="0.675444" stopColor="#D1D2D9" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint12_linear_65522_77341'}
          x1="90.4627"
          y1="111.636"
          x2="79.9524"
          y2="137.557"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8F8F9" stopOpacity="0.78" />
          <stop offset="0.319253" stopColor="#F8F8F9" stopOpacity="0" />
          <stop offset="0.615431" stopColor="white" stopOpacity="0" />
          <stop offset="0.867925" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint13_linear_65522_77341'}
          x1="100.297"
          y1="70.4395"
          x2="96.7622"
          y2="84.1556"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint14_linear_65522_77341'}
          x1="99.34"
          y1="73.7462"
          x2="46.9774"
          y2="148.014"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#594530" />
          <stop offset="0.667292" stopColor="#7A5D3F" />
          <stop offset="1" stopColor="#564029" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint15_linear_65522_77341'}
          x1="105.097"
          y1="71.6775"
          x2="40.1555"
          y2="141.242"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#926C45" />
          <stop offset="0.198565" stopColor="#B98D5F" />
          <stop offset="0.568549" stopColor="#B98D5F" />
          <stop offset="1" stopColor="#94693C" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint16_linear_65522_77341'}
          x1="87.4167"
          y1="100.554"
          x2="88.8877"
          y2="114.306"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B98D5F" />
          <stop offset="0.0810439" stopColor="#B98D5F" />
          <stop offset="0.312564" stopColor="#ECD4AF" />
          <stop offset="0.465883" stopColor="#FDEED8" />
          <stop offset="0.619479" stopColor="#ECD4AF" />
          <stop offset="0.845306" stopColor="#B98D5F" />
          <stop offset="1" stopColor="#B98D5F" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint17_linear_65522_77341'}
          x1="96.03"
          y1="97.1322"
          x2="47.1749"
          y2="134.274"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00453841" stopColor="#B98D5F" />
          <stop offset="0.184436" stopColor="white" />
          <stop offset="0.808004" stopColor="#D3B790" />
          <stop offset="0.912608" stopColor="#F7E1C2" />
          <stop offset="1" stopColor="#D3B790" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint18_linear_65522_77341'}
          x1="10.7212"
          y1="9.20255"
          x2="24.1083"
          y2="66.2673"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.220856" stopColor="#FAFAFA" />
          <stop offset="1" stopColor="#D8D9E1" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint19_linear_65522_77341'}
          x1="10.3906"
          y1="9.28551"
          x2="40.8843"
          y2="81.2968"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8F8F9" stopOpacity="0.46" />
          <stop offset="0.575358" stopColor="#F8F8F9" />
          <stop offset="0.783289" stopColor="white" />
          <stop offset="0.884809" stopColor="white" stopOpacity="0.19" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint20_linear_65522_77341'}
          x1="12.2225"
          y1="37.269"
          x2="23.2067"
          y2="82.9628"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.220856" stopColor="#FAFAFA" />
          <stop offset="1" stopColor="#D8D9E1" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint21_linear_65522_77341'}
          x1="11.7138"
          y1="37.407"
          x2="34.1161"
          y2="96.2867"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8F8F9" stopOpacity="0.46" />
          <stop offset="0.292773" stopColor="#F8F8F9" stopOpacity="0.45" />
          <stop offset="0.629289" stopColor="white" stopOpacity="0.51" />
          <stop offset="0.742389" stopColor="white" stopOpacity="0.12" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint22_linear_65522_77341'}
          x1="28.1099"
          y1="83.4075"
          x2="28.9155"
          y2="93.0208"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.374859" stopColor="#AD8357" />
          <stop offset="0.986946" stopColor="#714538" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint23_linear_65522_77341'}
          x1="19.9173"
          y1="64.1691"
          x2="28.798"
          y2="100.033"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.220856" stopColor="#FAFAFA" />
          <stop offset="1" stopColor="#D8D9E1" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint24_linear_65522_77341'}
          x1="19.4392"
          y1="64.2945"
          x2="34.9425"
          y2="111.543"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8F8F9" stopOpacity="0.46" />
          <stop offset="0.21882" stopColor="#F8F8F9" stopOpacity="0.67" />
          <stop offset="0.45675" stopColor="white" stopOpacity="0.46" />
          <stop offset="0.742389" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint25_linear_65522_77341'}
          x1="31.4344"
          y1="94.3469"
          x2="32.858"
          y2="102.848"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.374859" stopColor="#AD8357" />
          <stop offset="0.986946" stopColor="#714538" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint26_linear_65522_77341'}
          x1="31.7133"
          y1="96.5625"
          x2="29.0973"
          y2="116.621"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EFEFEF" />
          <stop offset="0.411026" stopColor="#DEDFE6" />
          <stop offset="0.58979" stopColor="#D1D2D9" />
          <stop offset="1" stopColor="#D1D2D9" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint27_linear_65522_77341'}
          x1="10.3216"
          y1="91.793"
          x2="32.0779"
          y2="114.196"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8F8F9" stopOpacity="0.86" />
          <stop offset="0.319253" stopColor="#F8F8F9" />
          <stop offset="0.615431" stopColor="white" stopOpacity="0.88" />
          <stop offset="0.867925" stopColor="white" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint28_linear_65522_77341'}
          x1="40.481"
          y1="111.146"
          x2="45.0553"
          y2="107.607"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.374859" stopColor="#AD8357" />
          <stop offset="0.986946" stopColor="#714538" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint29_linear_65522_77341'}
          x1="47.3528"
          y1="110.488"
          x2="45.9148"
          y2="135.243"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0306468" stopColor="#DBDCE7" />
          <stop offset="0.274204" stopColor="#CBCCD7" />
          <stop offset="0.675444" stopColor="#D1D2D9" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint30_linear_65522_77341'}
          x1="42.8556"
          y1="111.636"
          x2="53.366"
          y2="137.557"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8F8F9" stopOpacity="0.78" />
          <stop offset="0.319253" stopColor="#F8F8F9" stopOpacity="0" />
          <stop offset="0.615431" stopColor="white" stopOpacity="0" />
          <stop offset="0.867925" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint31_linear_65522_77341'}
          x1="33.0216"
          y1="70.4395"
          x2="36.5562"
          y2="84.1556"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint32_linear_65522_77341'}
          x1="33.9784"
          y1="73.7462"
          x2="86.3409"
          y2="148.014"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#594530" />
          <stop offset="0.667292" stopColor="#7A5D3F" />
          <stop offset="1" stopColor="#564029" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint33_linear_65522_77341'}
          x1="28.2214"
          y1="71.6775"
          x2="93.1628"
          y2="141.242"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#926C45" />
          <stop offset="0.198565" stopColor="#B98D5F" />
          <stop offset="0.568549" stopColor="#B98D5F" />
          <stop offset="1" stopColor="#94693C" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint34_linear_65522_77341'}
          x1="45.9017"
          y1="100.554"
          x2="44.4306"
          y2="114.306"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B98D5F" />
          <stop offset="0.0810439" stopColor="#B98D5F" />
          <stop offset="0.312564" stopColor="#ECD4AF" />
          <stop offset="0.465883" stopColor="#FDEED8" />
          <stop offset="0.619479" stopColor="#ECD4AF" />
          <stop offset="0.845306" stopColor="#B98D5F" />
          <stop offset="1" stopColor="#B98D5F" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint35_linear_65522_77341'}
          x1="37.2884"
          y1="97.1322"
          x2="86.1435"
          y2="134.274"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00453841" stopColor="#B98D5F" />
          <stop offset="0.184436" stopColor="white" />
          <stop offset="0.808004" stopColor="#D3B790" />
          <stop offset="0.912608" stopColor="#F7E1C2" />
          <stop offset="1" stopColor="#D3B790" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint36_linear_65522_77341'}
          x1="67.3367"
          y1="110.845"
          x2="57.5633"
          y2="123.887"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5D7D9" />
          <stop offset="1" stopColor="#E2E3E7" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint37_linear_65522_77341'}
          x1="64.8474"
          y1="128.297"
          x2="81.0561"
          y2="127.185"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9A9CA5" />
          <stop offset="0.259135" stopColor="#C4C6CF" />
          <stop offset="0.878536" stopColor="#E2E3E7" />
        </linearGradient>
        <linearGradient
          id={idPrefix + 'paint38_linear_65522_77341'}
          x1="57.1057"
          y1="107.877"
          x2="69.6218"
          y2="105.846"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F4F5F8" />
          <stop offset="1" stopColor="#F5F6F7" />
        </linearGradient>
      </defs>
    </svg>
  )
}
